// @flow
/* eslint-disable react/no-danger */
import React from 'react';
import bem from '@justpark/helpers/src/bem/bem';

import '../../../../static/scss/components/predictiveSearchResultsItem.scss';

type Props = {
  onClickResult: (...args: Array<any>) => any,
  onHoverResult: (...args: Array<any>) => any,
  index: number,
  item: any,
  isActive?: boolean,
  resultItemRef?: any
};

const baseClass = 'c-predictive-search-input__result-item';

const SearchResultsItem = ({
  index,
  resultItemRef = null,
  item,
  onClickResult,
  onHoverResult,
  isActive = false
}: Props) => {
  return (
    <div
      ref={resultItemRef}
      onMouseDown={() => onClickResult(index)}
      onMouseMove={() => onHoverResult(index)}
      className={bem(baseClass, null, {
        highlight: isActive,
        justpark: item.type === 'driveup',
        google: item.type === 'google'
      })}
      data-cy="predictive-search-input__result-item"
    >
      <span
        dangerouslySetInnerHTML={{
          __html: item.html
        }}
      />
    </div>
  );
};

export default SearchResultsItem;
